<template>
    <div class="wrapper" v-auto-close="autoClose">
        <div class="field is-marginless">
            <p class="control" :class="icon != null ? 'has-icons-left': ''">
                <input class="input" :class="`is-${size}`" ref="input" type="text" :placeholder="placeholder" autocomplete="off" readonly :value="getValue()" :tabindex="tabindex" :autofocus="autofocus" @mousedown="togglePicker" @focus="togglePicker" @blur="togglePicker" :disabled="disabled" >
                <span class="icon is-small is-left">
                    <i :class="`fas fa-${icon}`"></i>
                </span>
            </p>
        </div>
        <div class="panel" v-if="showPicker">
            <div class="columns is-mobile">
                <div class="column is-2">
                    <button class="button is-primary is-inverted is-small is-expanded" type="button" @mousedown="updateCalendar('prev', $event)">
                        <span class="icon">
                            <i class="fas fa-arrow-left"></i>
                        </span>
                    </button>
                </div>
                <div class="column is-8 has-text-centered is-size-4">{{months[current.month()]}} {{current.year()}}</div>
                <div class="column is-2 has-text-right">
                    <button class="button is-primary is-inverted is-small is-expanded" type="button" @mousedown="updateCalendar('next', $event)">
                        <span class="icon">
                            <i class="fas fa-arrow-right"></i>
                        </span>
                    </button>
                </div>
            </div>
            <div class="columns is-mobile">
                <div class="column has-text-centered is-size-7" v-for="(day, index) in daysOfWeek" :key="index">{{day}}</div>
            </div>
            <div class="columns is-mobile" v-for="(week, index) in month" :key="index">
                <div class="column has-text-centered is-size-7" v-for="(day, dayIndex) in week" :key="dayIndex" @mousedown="selectDate(day, $event)" :class="{'today': isToday(day), 'date': day != null, 'selected': isSelected(day), 'disabled': isDisabled(day)}">
                    <span v-if="day != null">{{ day.date() }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AutoCloseDirective from "@directives/AutoClose/AutoCloseDirective";

import { isset, moment } from '@master';

export default {
    props: {
        value: Object,
        placeholder: String,
        mindate: Object,
        maxdate: Object,
        icon: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: "medium"
        },
        format: {
            type: String,
            default: 'YYYY-M-d'
        },
        tabindex: {
            type: Number,
            default: null
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            newValue: null,
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
            daysOfWeek: ['Sun', 'Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat'],
            month: [],
            today: moment(),
            current: null,
            showPicker: false,
            htmlEvent: null
        };
    },
    methods: {
        togglePicker(event) {
            if(event.type == 'mousedown') {
                this.showPicker = !this.showPicker;
            } else if(event.type == 'focus') {
                this.showPicker = true;
            } else if(event.type == 'blur') {
                this.showPicker = false;
            }
        },
        generateCalendar(year, month) {
            this.current = moment({year: year, month: month});

            let daysInMonth = this.current.daysInMonth();
            let dayOfWeek = this.current.startOf('month').day();

            let week = 0;
            this.month.length = 0;
            this.month[week] = [];
            for(var i = 0; i < dayOfWeek; i++)
                this.month[week].push(null);
            for(var i = 1; i <= daysInMonth; i++) {
                if(this.month[week].length % 7 == 0) {
                    week++;
                    this.month[week] = [];
                }
                this.month[week].push(moment({year: this.current.year(), month: this.current.month(), date: i}));
            }
            for(var i = this.month[this.month.length - 1].length; i < 7; i++)
                this.month[this.month.length - 1].push(null);
        },
        getValue() {
            return this.newValue != null ? this.newValue.format(this.format) : '';
        },
        selectDate(day, event) {
            event.preventDefault();
            event.stopPropagation();
            if(this.isDisabled(day)) return false;
            this.showPicker = false;
            this.newValue = day;
            this.$emit('input', day);
            this.$refs.input.dispatchEvent(this.htmlEvent);
        },
        isToday(day) {
            return day != null && day.date() == this.today.date() && day.month() == this.today.month();
        },
        isSelected(day) {
            return day != null && this.newValue != null && day.date() == this.newValue.date() && day.month() == this.newValue.month() && day.year() == this.newValue.year();
        },
        isDisabled(day) {
            if(day != null && isset(this.mindate) && day.isBefore(this.mindate)) {
                return true;
            }
            if(day != null && isset(this.maxdate) && day.isAfter(this.maxdate)) {
                return true;
            }
            return false;
        },
        updateCalendar(direction, event) {
            event.preventDefault();
            event.stopPropagation();
            let month = this.current.month();
            let year = this.current.year();
            if(direction == 'next') {
                month = this.current.add(1, 'month').month();
                year = this.current.year();
            }
            if(direction == 'prev') {
                month = this.current.subtract(1, 'month').month();
                year = this.current.year();
            }
            this.generateCalendar(year, month);
        },
        autoClose() {
            this.showPicker = false;
        }
    },
    mounted() {
        let value = null;

        if(this.value != null) {
            value = this.value;
            this.newValue = value;
        } else if (this.mindate != null) {
            value = this.mindate.clone();
            value = value.add(1, 'day');
        } else {
            value = moment();
        }

        this.generateCalendar(value.year(), value.month());

        this.htmlEvent = new Event('input');

    },
    watch: {
        value(val) { this.newValue = val; },
        mindate: function(newDate) {
            if(newDate != null) {
                this.generateCalendar(newDate.year(), newDate.month());
            }
        }
    },
    directives: {
        'auto-close': AutoCloseDirective
    }
}
</script>

<style scoped lang="scss">
@import "bulma/sass/utilities/all";
.wrapper {
    position: relative;
    .input {
        cursor: pointer;
    }
    .panel {
        background-color: #FFF;
        border: solid 1px rgb(219, 219, 219);
        left: 0px;
        max-width: 350px;
        padding: 16px;
        position: absolute;
        top: calc(100% - 1px);
        width: 100%;
        z-index: 50;
        .date {
            border: solid 1px #FFF;
        }
        .date:not(.disabled):hover {
            border: solid 1px #e05f52;
            color: #e05f52;
            cursor: pointer;
        }
        .disabled {
            color: hsl(0, 0%, 86%);
        }
        .today {
            background-color: hsl(0, 0%, 96%);
        }
        .selected {
            background-color: #e05f52!important;
            color: #FFF;
        }
        .selected:hover {
            color: #FFF;
        }
    }
}
@include desktop() {
    .wrapper .panel {
        width: 200%;
    }
}
</style>
